import { create } from "zustand";
import { persist } from "zustand/middleware";

const useStore = create(
  persist(
    (set) => ({
      kv: {},

      set: (key, value) =>
        set((state) => ({
          kv: { ...state.kv, [key]: value },
        })),

      remove: (key) =>
        set((state) => {
          const kv = { ...state.kv };
          delete kv[key];
          return { kv };
        }),

      clear: () => set({ kv: {} }),
    }),
    { name: "list-storage" }
  )
);

export default useStore;
